import template from './ticketViewList.template.html';

export default {
  template,
  bindings: {
    items: '=',
    accounts: '<',
    contacts: '<',
    partners: '<',
    noteLabels: '<',
    jobLabels: '<',
    fileLabels: '<',
    tickets: '<',
    showAssignedTo: '<',
    onPin: '&',
    onToggle: '&',
    onShareClient: '&',
    onSharePartner: '&',
    onLabelsSelect: '&',
    onRequestSignature: '&',
    onEdit: '&',
    onDelete: '&',
    onLock: '&',
    onDownload: '&',
    onDownloadPdf: '&',
    onRedactTfn: '&',
    onRename: '&',
    onPreview: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listServiceNew) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = null;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.list.setData(ctrl.items);
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.itemPin = ($event, item) => {
        ctrl.onPin({ event: $event, item });
      };

      ctrl.itemToggle = (item) => {
        ctrl.onToggle({ item });
      };

      ctrl.itemShareClient = ($event, item) => {
        ctrl.onShareClient({ event: $event, item });
      };

      ctrl.itemSharePartner = ($event, item) => {
        ctrl.onSharePartner({ event: $event, item });
      };

      ctrl.itemLabelsSelect = ($event, item) => {
        ctrl.onLabelsSelect({ event: $event, item });
      };

      ctrl.itemRequestSignature = ($event, item, type, isNonEmbedded) => {
        ctrl.onRequestSignature({ event: $event, item, type, isNonEmbedded });
      };

      ctrl.itemEdit = ($event, item) => {
        ctrl.onEdit({ event: $event, item });
      };

      ctrl.itemDelete = ($event, item) => {
        ctrl.onDelete({ event: $event, item });
      };

      ctrl.itemLock = ($event, item) => {
        ctrl.onLock({ event: $event, item });
      };

      ctrl.itemDownload = ($event, item) => {
        ctrl.onDownload({ event: $event, item });
      };

      ctrl.itemDownloadPdf = ($event, item) => {
        ctrl.onDownloadPdf({ event: $event, item });
      };

      ctrl.itemRedactTfn = ($event, item) => {
        ctrl.onRedactTfn({ event: $event, item });
      };

      ctrl.itemRename = ($event, item) => {
        ctrl.onRename({ event: $event, item });
      };

      ctrl.itemPreview = ($event, item) => {
        ctrl.onPreview({ event: $event, item });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.items && changes.items.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
